<template>
    <div class="h-100 d-flex justify-content-center align-items-center" v-if="loadingDashboard">
        <vue-loaders-ball-beat scale="2" color="black" />
    </div>
    <div v-else>
        <div style="clear:both; border-bottom:solid 1px #ccc; margin-top:1rem;">
            <a @click="changeTab('n')">
                <button :class="[tabStatus === 'n' ? 'dashTab-selected' : 'dashTab']" class="newTab">NEW SUBMISSIONS</button>
            </a>
            <a @click="changeTab('p')">
                <button :class="[tabStatus === 'p' ? 'dashTab-selected' : 'dashTab']" class="outForApprovalTab">OUT FOR APPROVAL</button>
            </a>
            <a @click="changeTab('a')">
                <button :class="[tabStatus === 'a' ? 'dashTab-selected' : 'dashTab']" class="approvedTab">APPROVED</button>
            </a>
            <a @click="changeTab('e')">
                <button :class="[tabStatus === 'e' ? 'dashTab-selected' : 'dashTab']" class="erpTab">ENTERED INTO ERP</button>
            </a>
            <a @click="changeTab('d')">
                <button :class="[tabStatus === 'd' ? 'dashTab-selected' : 'dashTab']" class="deniedTab">DENIED</button>
            </a>
        </div>
        <br>
        <priceworkflow-dashboard-pagination
            :totalSubmissions="totalSubmissions"
            :previousPageLink="previousPageLink"
            :nextPageLink="nextPageLink"
            :currPage="currPage"
            :totalPages="totalPages"
            @change-page="changePage"
        ></priceworkflow-dashboard-pagination>
        <br>
        <div class="dashboardActionBar">
            <button @click="clearFilters()" class="btn-round-red" type="button">
                Clear Filters
            </button>

            <span class="actionDivider"></span>

            <button @click="expandAll()" class="btn-round-green" type="button">
                Expand All
            </button>

            <button @click="collapseAll()" class="btn-round-red" type="button">
                Collapse All
            </button>
        </div>
        <br>
        <table class="submissionTBL">
            <tr class="TBLhead">
                <th v-if="bulkActionsAvailable" style="width:5%;">BULK SELECT</th>
                <th style="width:8%;">{{ submittedColHeader }}</th>
                <th style="width:5%;">
                    <a id="btFil" style="cursor:pointer;" @click="toggleFilterField('bt')">
                        <img src="/images/price-workflow/icon-filter-gray.png" width="12" height="12" />
                    </a>
                    <span v-if="!displayBtFilter" id="btHeader">BT</span>
                    <span v-else id="btFilterField">
                        <input id="btField" type="text" v-model="filters.bt" placeholder="BT Filter" style="width:80%;"/>
                    </span>
                </th>
                <th style="width:12%;">
                    <a id="companyFil" style="cursor:pointer;" @click="toggleFilterField('company')">
                        <img src="/images/price-workflow/icon-filter-gray.png" width="12" height="12" />
                    </a>
                    <span v-if="!displayCompanyFilter" id="companyHeader">COMPANY</span>
                    <span v-else id="companyFilterField">
                        <input id="companyField" type="text" v-model="filters.company" placeholder="Company Filter" style="width:80%;"/>
                    </span>
                </th>
                <th style="width:12%;">
                    <a id="activityFil" style="cursor:pointer;" @click="toggleFilterField('activity')">
                        <img src="/images/price-workflow/icon-filter-gray.png" width="12" height="12" />
                    </a>
                    <span v-if="!displayActivityFilter" id="activityHeader">ACTIVITY</span>
                    <span v-else id="activityFilterField">
                        <admin-select id="activityField" v-model="filters.activity" style="width:80%;">
                            <option value="">Activity Filter</option>
                            <option :value="1">Ongoing Pricing Deviation</option>
                            <option :value="2">One-Time Price Adjustment</option>
                            <option :value="4">Promotion</option>
                        </admin-select>
                    </span>
                </th>
                <th v-if="tabStatus == 'p'" style="width:8%;">
                    <a id="currStepFil" style="cursor:pointer;" @click="toggleFilterField('currStep')">
                        <img src="/images/price-workflow/icon-filter-gray.png" width="12" height="12" />
                    </a>
                    <span v-if="!displayCurrStepFilter" id="currStepHeader">CURRENT STEP</span>
                    <span v-else id="currStepFilterField">
                        <admin-select id="currStepField" v-model="filters.currStep" style="width:80%;">
                            <option value="">Current Step Filter</option>
                            <option :value="1">RSM</option>
                            <option :value="2">SD</option>
                            <option :value="3">VP</option>
                            <option :value="4">EXEC</option>
                        </admin-select>
                    </span>
                </th>
                <th style="width:12%;">RATIONALE</th>
                <th style="width:8%;">EFF DATE</th>
                <th style="width:8%;">
                    <a id="styleFil" style="cursor:pointer;" @click="toggleFilterField('style')">
                        <img src="/images/price-workflow/icon-filter-gray.png" width="12" height="12" />
                    </a>
                    <span v-if="!displayStyleFilter" id="styleHeader">STYLE</span>
                    <span v-else id="styleFilterField">
                        <input id="styleField" type="text" v-model="filters.style" placeholder="Style Filter" style="width:80%;"/>
                    </span>
                </th>
                <th style="width:7%;">PRICE</th>
                <th style="width:7%;">VAR% LIST</th>
                <th style="width:8%;">PROJ SALES</th>
                <th colspan="3" style="text-align:center;width:10%;">ACTIONS</th>
            </tr>
            <template v-for="entry in submissions">
                <tr>
                    <td v-if="bulkActionsAvailable">
                        <!-- {{ entry.id }} -->
                        <input v-if="isAdmin || ((entry.canBeSubmitted && entry.child_submissions.length == 0) || (tabStatus == 'p' && entry.canBeSignedOffOn) || (tabStatus == 'a'))" type="checkbox" class="submissionId" :value="entry.id" v-model="selectedIds" />
                        <input v-else type="checkbox" disabled="disabled" style="cursor:not-allowed;" />
                    </td>
                    <td>
                        <a @click="toggleDetails(entry.id, entry.isMulti)" style="cursor:pointer;">
                            <span class="arrow-down">&#x25BC;</span>
                        </a>
                        {{ entry.timestamp }}
                    </td>
                    <td>{{ entry.cust_id }}</td>
                    <td>{{ entry.company }}</td>
                    <td>
                        <img v-if="entry.urgent" src="/images/price-workflow/icon-circle-important.png" style="position:relative; height:1rem; width:auto;">
                        {{ entry.activity.activity }}
                    </td>
                    <td v-if="tabStatus == 'p'" style="text-transform:uppercase;">{{ entry.currentStep }}</td>
                    <td>{{ entry.rationale }}</td>
                    <td v-if="entry.act_id == 2 && entry.ord_num" v-html="entry.ord_num"></td>
                    <td v-else>{{ entry.eff_date }}</td>
                    <td>
                        <img v-if="entry.tariff_flag" src="/images/price-workflow/icon-alert.gif" style="position:relative; height:1rem; width:auto;">
                        {{ entry.prod_key }}
                    </td>
                    <td>{{ entry.sug_price }} {{ entry.uom }}<span class="deviatedFlag" v-if="entry.on_deviated == '1'">*</span></td>
                    <td>{{ entry.sug_var }}</td>
                    <td>{{ entry.proj_sales }}</td>
                    <td v-if="entry.canBeSubmitted" class="iconTd">
                        <a @click="submitEntry(entry.id)">
                            <img class="iconImg" src="/images/icon-circle-submit.png" />
                        </a>
                        <p v-if="!entry.isMulti"class="iconLabel">SUBMIT</p>
                        <p v-else class="iconLabel">SUBMIT FAMILY</p>
                    </td>
                    <td v-if="entry.isMulti" class="iconTd">
                        <router-link :to="{ name: 'PriceWorkflowViewFamily', params: {parentId: entry.id }}">
                            <img class="iconImg" src="/images/icon-circle-view-green.png" />
                        </router-link>
                        <p class="iconLabel">VIEW FAMILY</p>
                    </td>
                    <td v-else-if="tabStatus != 'n'" class="iconTd">
                        <router-link :to="{ name: 'PriceWorkflowSignoff', params: {ppId: entry.id}}">
                            <img class="iconImg" src="/images/icon-circle-view-green.png" />
                        </router-link>
                        <p class="iconLabel">VIEW</p>
                    </td>
                    <td v-if="tabStatus == 'a'" class="iconTd">
                        <a @click="openExportModal(entry.id)">
                            <img class="iconImg" src="/images/icon-circle-download.png" alt="Download ERP Export" />
                        </a>
                        <p v-if="!entry.isMulti" class="iconLabel">EXPORT</p>
                        <p v-else class="iconLabel">EXPORT FAMILY</p>
                    </td>
                    <td v-if="!entry.isMulti && (tabStatus == 'n' || (tabStatus == 'd' && entry.edittableByCurrUser))" class="iconTd">
                        <router-link :to="{ 
                                name: 'PriceWorkflowSkuSelect', 
                                params: {ppId: entry.id},
                                query: { editing: true }
                            }"
                        >
                            <img class="iconImg" src="/images/icon-circle-edit.png" />
                        </router-link>
                        <p class="iconLabel">EDIT</p>
                    </td>
                    <td v-if="!entry.isMulti && (tabStatus == 'n' || tabStatus == 'd' || isAdmin)" class="iconTd">
                        <a @click="deleteEntryEmitter(entry.id)">
                            <img class="iconImg" src="/images/icon-circle-trash.png" />
                        </a>
                        <p class="iconLabel">DELETE</p>
                    </td>
                </tr>
                <dev-dashboard-add-details-row v-if="!entry.isMulti"
                    :entry="entry"
                ></dev-dashboard-add-details-row>
                <dev-dashboard-children-rows
                    v-else-if="entry.child_submissions && entry.child_submissions.length > 0"
                    :children="entry.child_submissions"
                    :parent-id="entry.id"
                    :bulk-actions-available="bulkActionsAvailable"
                    :is-admin="isAdmin"
                    :tab-status="tabStatus"
                    :selected-ids="selectedIds"
                    :user="user"
                    @update:selectedIds="selectedIds = $event"
                    @toggle-details="toggleDetails"
                    @submit-entry="submitEntry"
                    @delete-entry="deleteEntryEmitter"
                    @open-export-modal="openExportModal"
                ></dev-dashboard-children-rows>
            </template>
        </table>
        <ul v-if="bulkActionsAvailable" id="bulkActionUl">
            <li style="border-right: 1px solid black;padding-right:10px;">
                <input type="checkbox" id="checkAll" @click="checkAll()" style="padding: 0 10px 0 1px; color:#999;"> SELECT ALL
            </li>
            <li>
                <span><strong>BULK ACTIONS: </strong></span>
            </li>
            <li v-if="tabStatus == 'n'">
                <button 
                    @click="getConfirmation('bulkSubmit', 'p');" 
                    class="btn-round-green" 
                    type="button" 
                    :disabled="loadingBulkAction"
                    style="margin-top:0;"
                >
                    SUBMIT
                </button>
            </li>
            <li v-if="tabStatus == 'p'">
                <button 
                    @click="getConfirmation('bulkApprove', 'a');" 
                    class="btn-round-green" 
                    type="button" 
                    :disabled="loadingBulkAction"
                    style="margin-top:0;"
                >
                    APPROVE
                </button>
            </li>
            <li v-if="tabStatus == 'a'">
                <button 
                    @click="getConfirmation('bulkErp', 'e');" 
                    class="btn-round-green" 
                    type="button" 
                    :disabled="loadingBulkAction"
                    style="margin-top:0;"
                >
                    APPROVE ERP
                </button>
            </li>
            <li v-if="tabStatus == 'n' || tabStatus == 'p' || tabStatus == 'a'">
                <button 
                    @click="getConfirmation('bulkDelete', 'd');" 
                    class="btn-round-red" 
                    type="button" 
                    :disabled="loadingBulkAction"
                    style="margin-top:0;"
                >
                    DELETE
                </button>
            </li>
            <li v-if="loadingBulkAction">
                <vue-loaders-ball-beat scale="1" color="black" />
            </li>
        </ul>
        <br>
        <priceworkflow-dashboard-pagination
            :totalSubmissions="totalSubmissions"
            :previousPageLink="previousPageLink"
            :nextPageLink="nextPageLink"
            :currPage="currPage"
            :totalPages="totalPages"
            @change-page="changePage"
        ></priceworkflow-dashboard-pagination>
        <priceworkflow-export-modal
            v-if="showExportModal"
            :ppId="exportSubmissionId"
            @close="closeExportModal"
            @confirm="confirmExport"
        />
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    data() {
        return {
            bulkActionsAvailable: false,
            bulkSelect: [],
            currPage: "",
            displayActivityFilter: false,
            displayBtFilter: false,
            displayCompanyFilter: false,
            displayCurrStepFilter: false,
            displayStyleFilter: false,
            exportSubmissionId: null,
            filters: {
                activity: "",
                bt: "",
                company: "",
                currStep: "",
                style: ""
            },
            isAdmin: false,
            loadingBulkAction: false,
            loadingDashboard: true,
            nextPageLink: "",
            paginationResults: {},
            previousPageLink: "",
            selectedIds: [],
            showExportModal: false,
            submissions: [],
            submittedColHeader: "STARTED",
            tabStatus: this.$route.params.status || "n",
            totalPages: "",
            totalSubmissions: "",
        }
    },
    created() {
        if(this.user != null && this.user.user_group_id != null) {
            this.getPaginationResults();
        }

        this.$parent.$on('triggerPriceDeviationDashboardRefresh', () => {
            // Reset checkboxes and selectedIds
            $('#checkAll').prop('checked', false);
            $('.submissionId').prop('checked', false);
            this.selectedIds = [];

            this.getPaginationResults();
        });
    },
    watch: {
        paginationResults() {
            this.submissions = this.paginationResults['data'];
            this.totalSubmissions = this.paginationResults['total'];
            this.currPage = this.paginationResults['current_page'];
            this.totalPages = this.paginationResults['last_page'];
            this.previousPageLink = this.paginationResults['prev_page_url'];
            this.nextPageLink = this.paginationResults['next_page_url'];

            this.loadingDashboard = false;
            this.loadingBulkAction = false;
        },
        user () {
            this.getPaginationResults();
            this.findIfAdmin();
        },
        tabStatus: {
            handler() {
                $(".dashTab-selected").attr("class", "dashTab");

                if(this.tabStatus == "n") {
                    $(".newTab").attr("class", "dashTab-selected");
                    this.submittedColHeader = "STARTED";
                    this.bulkActionsAvailable = true;
                } else if (this.tabStatus == "p") {
                    $(".outForApprovalTab").attr("class", "dashTab-selected");
                    this.submittedColHeader = "SUBMITTED";
                    if(this.user.user_group_id != 10) {
                        this.bulkActionsAvailable = true;
                    } else {
                        this.bulkActionsAvailable = false;
                    }
                } else if (this.tabStatus == "a") {
                    $(".approvedTab").attr("class", "dashTab-selected");
                    this.submittedColHeader = "SUBMITTED";
                    if(this.priceERPAdmins.includes(this.user.id)) {
                        this.bulkActionsAvailable= true;
                    } else {
                        this.bulkActionsAvailable = false;
                    }
                } else if (this.tabStatus == "e") {
                    $(".erpTab").attr("class", "dashTab-selected");
                    this.submittedColHeader = "ENTERED";
                    this.bulkActionsAvailable = false;
                } else if (this.tabStatus == "d") {
                    $(".deniedTab").attr("class", "dashTab-selected");
                    this.submittedColHeader = "SUBMITTED";
                    this.bulkActionsAvailable = false;
                }
            },
            immediate: true
        },
        selectedIds() {
            if(this.selectedIds.length > 0 && this.selectedIds.length == $('.submissionId').length) {
                $("#checkAll").prop('checked', true);
            } else {
                $("#checkAll").prop('checked', false);
            }
        },
        filters: {
            handler() {
                this.getPaginationResults();
                this.selectedIds = [];
            },
            deep: true
        }
    },
    computed: {
        ...mapState({ 
            user: state => state.user,
            priceERPAdmins: state => state.priceERPAdmins,
            priceDeviationAdmins: state => state.priceDeviationAdmins
        })
    },
    methods: {
        findIfAdmin() {
            if(this.priceERPAdmins.includes(this.user.id) || this.priceDeviationAdmins.includes(this.user.id)) {
                this.isAdmin = true;
            } else {
                this.isAdmin = false;
            }
        },
        getPaginationResults() {
            axios.get(`/api/getPriceDeviationSubmissions/${this.tabStatus}/${this.user.id}/${this.priceDeviationAdmins}`, {
                params: {
                    activity: this.filters.activity,
                    bt: this.filters.bt,
                    company: this.filters.company,
                    currStep: this.filters.currStep,
                    style: this.filters.style
                }
            
            }).then(response => {
                this.paginationResults = response.data;
            });
        },
        changePage(link) {
            axios.get(link, {
                params: {
                    activity: this.filters.activity,
                    bt: this.filters.bt,
                    company: this.filters.company,
                    currStep: this.filters.currStep,
                    style: this.filters.style
                }
            }).then(response => {
                this.paginationResults = response.data;
            });
        },
        changeTab(newStatus) {
            $(".additionalDetailsRow").hide();
            this.tabStatus = newStatus;
            this.clearFilters();
        },
        submitEntry(ppId) {
            this.loadingBulkAction = true;
            axios.post(`/api/submitEntry`, {ppId: ppId}).then(response => {
                const submission = response.data;

                if(submission.isMulti) {
                    this.tabStatus = 'p';
                    this.getPaginationResults();
                    this.loadingBulkAction = false;
                } else {
                    this.$router.push({
                        name: "PriceWorkflowSignoff",
                        params: { ppId: ppId }
                    });
                }
            });
        },
        deleteEntryEmitter(ppId) {
            if(confirm("Did you mean to click DELETE? This will remove the selected Price Deviation from the database.")) {
                this.$emit('delete-entry', ppId);
            }
        },
        checkAll() {
            if ($("#checkAll").prop('checked') == true) {
                this.selectedIds = [];

                for (let submission of this.submissions) {
                    let checkbox = document.querySelector(`input.submissionId[value="${submission.id}"]`);

                    if (checkbox && !checkbox.disabled) {
                        this.selectedIds.push(submission.id);
                    }
                }
            } else {
                this.selectedIds = [];
            }
        },
        getConfirmation(action, status) {
            if ($('[class="submissionId"]:checked').length > 0) {

                if (action === "bulkSubmit") {
                    const invalidIds = this.getInvalidBulkSubmitIds();

                    if (invalidIds.length > 0) {
                        alert(`Some selected submissions cannot be submitted. To be submitted, an entry must have a selected style and suggested price. Please review the selected items and try again.`);
                        return false;
                    }
                } else if(action == "bulkApprove") {
                    const invalidIds = this.getInvalidBulkApproveIds();

                    if (invalidIds.length > 0) {
                        alert(`Bulk Approve cannot be performed on families from the dashboard. Open the family page (Actions → “VIEW FAMILY”) and approve there, or expand the family and select specific rows.`);
                        return false;
                    }
                }

                let confirmMsg = this.getConfirmMsg(action);
                let confirmVal = confirm(confirmMsg);

                if(confirmVal) {
                    this.bulkActionEmitter(action, status);
                } else {
                    return false;
                }
            } else {
                alert("No submissions were selected to take action on.");
            }
        },
        getConfirmMsg(action) {
            if(action == "bulkSubmit") {
                return "Are you sure you want to submit all of the selected items? Once confirmed the database will be updated for each entry.";
            } else if(action == "bulkApprove" || action == "bulkErp") {
                return "Are you sure you wish to bulk approve the selected items? Once confirmed the database will be updated for each entry.";
            } else if(action == "bulkDelete") {
                return "Are you sure you want to delete all of the selected items? Once confirmed each entry will be removed and this action cannot be undone.";
            }
        },
        bulkActionEmitter(action, status) {
            this.loadingBulkAction = true;

            this.$emit('bulk-action', {
                action: action, 
                signOffStatus: status, 
                submissionIds: this.selectedIds, 
                userId: this.user.id
            });
        },
        toggleFilterField(filter) {
            // toggle corresponding filter to hide it and show the filter field
            if(filter == "bt") {
                this.displayBtFilter = !this.displayBtFilter;
            } else if(filter == "company") {
                this.displayCompanyFilter = !this.displayCompanyFilter;
            } else if(filter == "activity") {
                this.displayActivityFilter = !this.displayActivityFilter;
            } else if(filter == "currStep") {
                this.displayCurrStepFilter = !this.displayCurrStepFilter;
            } else if(filter == "style") {
                this.displayStyleFilter = !this.displayStyleFilter;
            }
        },
        clearFilters() {
            for(let filter in this.filters) {
                this.filters[filter] = "";
            }

            this.displayBtFilter = false;
            this.displayCompanyFilter = false;
            this.displayActivityFilter = false;
            this.displayCurrStepFilter = false;
            this.displayStyleFilter = false;

            this.getPaginationResults();
        },
        toggleDetails(id, isMulti) {
            if(isMulti) {
                $(`.childrenRow[data-parent-id="${id}"]`).toggle();
            } else {
                $("#detailsRow_" + id).toggle();
            }
        },
        expandAll() {
            for (const entry of this.submissions) {
                if (entry.isMulti) {
                    // show all child rows for this parent
                    $(`.childrenRow[data-parent-id="${entry.id}"]`).show();

                    // show each child's additional details row too
                    if (entry.child_submissions && entry.child_submissions.length > 0) {
                        for (const child of entry.child_submissions) {
                            $(`#detailsRow_${child.id}`).show();
                        }
                    }
                } else {
                    // show singleton additional details row
                    $(`#detailsRow_${entry.id}`).show();
                }
            }
        },
        collapseAll() {
            for (const entry of this.submissions) {
                if (entry.isMulti) {
                    $(`.childrenRow[data-parent-id="${entry.id}"]`).hide();

                    if (entry.child_submissions && entry.child_submissions.length > 0) {
                        for (const child of entry.child_submissions) {
                            $(`#detailsRow_${child.id}`).hide();
                        }
                    }
                } else {
                    $(`#detailsRow_${entry.id}`).hide();
                }
            }
        },
        getSubmissionLookup() {
            const lookup = {};

            for (const entry of this.submissions) {
                lookup[entry.id] = entry;

                if (entry.child_submissions && entry.child_submissions.length > 0) {
                    for (const child of entry.child_submissions) {
                        lookup[child.id] = child;
                    }
                }
            }

            return lookup;
        },
        getInvalidBulkSubmitIds() {
            const lookup = this.getSubmissionLookup();

            return this.selectedIds.filter(id => {
                const submission = lookup[id];

                if (!submission) {
                    return true;
                }
                
                return !submission.canBeSubmitted || Number(submission.id) !== Number(submission.parent_id);
            });
        },
        getInvalidBulkApproveIds() {
            const lookup = this.getSubmissionLookup();

            return this.selectedIds.filter(id => {
                const submission = lookup[id];

                // treat missing entries as invalid
                if (!submission) {
                    return true;
                }

                // parents/families are not allowed for bulk approve
                return submission.isMulti === true;
            });
        },
        async exportEntry(ppId) {
            try {
                const response = await axios.post(
                    `/api/exportSubmission`,
                    { ppId: ppId },
                    { responseType: 'blob' }
                );

                let timestamp = new Date().toISOString().replace(/[:.-]/g, '');
                let fileName = `PIP-Retail-Pricing-Deviation-Export-${timestamp}.csv`;

                const disposition = response.headers['content-disposition'];
                if (disposition) {
                    const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
                    if (fileNameMatch && fileNameMatch[1]) {
                        fileName = fileNameMatch[1];
                    }
                }

                const blob = new Blob([response.data], {
                    type: response.headers['content-type'] || 'application/octet-stream'
                });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Export failed:', error);
                alert('There was an issue exporting this submission.');
            }
        },
        openExportModal(ppId) {
            this.exportSubmissionId = ppId;
            this.showExportModal = true;
        },
        closeExportModal() {
            this.showExportModal = false;
            this.exportSubmissionId = null;
        },
        confirmExport(exportOptions) {
            this.showExportModal = false;

            this.exportPricingSubmission(exportOptions.ppId, exportOptions);

            this.exportSubmissionId = null;
        },
        async exportPricingSubmission(ppId, options = {}) {
            try {
                const response = await axios.post(
                    `/api/exportPricingSubmission`,
                    {
                        ppId: ppId,
                        includeCustomItems: options.includeCustomItems || false,
                        includeServiceItems: options.includeServiceItems || false,
                    },
                    { responseType: 'blob' }
                );

                let timestamp = new Date().toISOString().replace(/[:.-]/g, '');
                let fileName = `PIP-Retail-Pricing-Deviation-Export-${timestamp}.csv`;

                const disposition = response.headers['content-disposition'];
                if (disposition) {
                    const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
                    if (fileNameMatch && fileNameMatch[1]) {
                        fileName = fileNameMatch[1];
                    }
                }

                const blob = new Blob([response.data], {
                    type: response.headers['content-type'] || 'application/octet-stream'
                });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Export failed:', error);
                alert('There was an issue exporting this submission.');
            }
        },
    },
    beforeDestroy() {
        this.$parent.$off('triggerPriceDeviationDashboardRefresh');
    }
}
</script>

<style scoped>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    .TBLhead th {
        font-weight: bold;
        border-bottom: solid 1px #333;
        margin-bottom: 0;
        vertical-align: bottom;
        text-align: left;
    }

    .submissionTBL {
        width: 100%;
        margin: 0;
        text-align: left;
        font-size: 0.9rem;
    }

    .iconImg {
        height:26px; 
        width:auto;
    }

    .iconTd {
        text-align:center; 
        width:2%;
        cursor: pointer;
        vertical-align: top;
    }

    .iconTd a {
        display: inline-block;
    }

    .iconLabel {
        font-size:0.6rem; 
        color:#999;
        text-align: center;
        margin: 0.2rem 0 0;
        line-height: 1.1;
    }

    .dashTab {
        position: relative;
        top: 1px;
        font-family: Arial;
        font-size: 0.8rem;
        line-height: 1.6rem;
        background: #fff;
        border: solid 1px #ccc;
        padding: 0.8rem 1rem;
        color: #999;
        cursor: pointer;
        width: 11rem;
    }

    .dashTab-selected {
        position: relative;
        top: 1px;
        font-family: Arial;
        font-size: 0.8rem;
        line-height: 1.6rem;
        border: solid 1px #ccc;
        border-left: 0px;
        padding: 0.8rem 1rem;
        cursor: pointer;
        width: 11rem;
        background-color: #cd1b00;
        background: #cd1b00;
        color: #fff;
    }

    .submissionTBL td {
        padding: 1rem .25rem 1rem 0;
        background: #fff;
        border-bottom: dotted 1px #ccc;
    }

    #bulkActionUl {
        list-style-type:none; 
        display:flex; 
        flex-wrap:wrap; 
        align-items:center; 
        margin-top:5px;
    }

    #bulkActionUl li {
        padding-left:10px;
    }

    .arrow-down {
        cursor: pointer;
        font-size: .6rem;
    }

    .arrow-down:hover {
        color: #cd1b00;
    }

    .deviatedFlag {
        color: red;
        font-weight: bold;
        margin-left: 2px;
    }

    .dashboardActionBar {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        margin-bottom: 0.5rem;
    }

    .actionDivider {
        align-self: stretch;
        width: 1px;
        background-color: #ccc;
        margin: 0 0.5rem;
    }

    .dashboardActionBar button {
        margin-top: 0;
    }
</style>
